<template>
    <div class="create-table">
        <a-tabs>
            <a-tab-pane key="templates" :tab="$t('tables.templates')">
                <div class="template-grid">
                    <div v-for="(template, index) in templates" :key="index" class="template-card">
                        <a-card :title="template.name">
                            <p>{{ template.description }}</p>
                            <a-button type="primary" @click="createTableFromTemplate(template.id)">{{ $t("tables.createTable") }}</a-button>
                        </a-card>
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane key="blank" :tab="$t('tables.blankTable')">
                <a-form :model="table" layout="vertical">
                    <a-form-item :label="$t('tables.tableName')">
                        <a-input v-model:value="table.name" />
                    </a-form-item>
                    <a-form-item :label="$t('tables.description')">
                        <a-textarea v-model:value="table.description" />
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" @click="createTable">{{ $t("tables.createTable") }}</a-button>
                    </a-form-item>
                </a-form>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
export default {
    name: "CreateTable",
    data() {
        return {
            templates: [
                {
                    id: "default",
                    name: this.$t("tables.customerTable"),
                    description: this.$t("tables.customerTableDesc"),
                },
                {
                    id: "lead_tracker",
                    name: this.$t("tables.leadTracking"),
                    description: this.$t("tables.leadTrackingDesc"),
                },
                {
                    id: "to_do_list",
                    name: this.$t("tables.todoList"),
                    description: this.$t("tables.todoListDesc"),
                },
                {
                    id: "approval_request",
                    name: this.$t("tables.approvalReq"),
                    description: this.$t("tables.approvalReqDesc"),
                },
                {
                    id: "event_schedule",
                    name: this.$t("tables.eventSchedule"),
                    description: this.$t("tables.eventScheduleDesc"),
                },
                {
                    id: "inventory_list",
                    name: this.$t("tables.inventoryList"),
                    description: this.$t("tables.inventoryListDesc"),
                },
                {
                    id: "booking_form",
                    name: this.$t("tables.bookingForm"),
                    description: this.$t("tables.bookingFormDesc"),
                },
                {
                    id: "bug_tracker",
                    name: this.$t("tables.bugTracker"),
                    description: this.$t("tables.bugTrackerDesc"),
                },
                {
                    id: "employee_directory",
                    name: this.$t("tables.employeeDirectory"),
                    description: this.$t("tables.employeeDirectoryDesc"),
                }
            ],
            table: {
                name: '',
                description: ''
            }
        };
    },
    methods: {
        createTableFromTemplate(templateId) {
            this.$emit("create", { template: templateId });
        },
        createTable() {
            this.$emit("create", this.table);
        }
    }
};
</script>

<style scoped lang="scss">
.template-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}
</style>
